import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from './layouts/AppLayout';
import ReadyOAuthCallback from './pages/ReadyOAuthCallback';
import DashboardPage from './pages/DashboardPage';
import ProjectsPage from './pages/ProjectsPage';
import MapPage from './pages/MapPage';
import DeScopePage from './pages/DeScopePage';
import GrantorBuilderPage from './pages/GrantorBuilderPage';
import GrantorQueuePage from './pages/GrantorQueuePage';
import GrantorLedgerPage from './pages/GrantorLedgerPage';
import ReassignmentPage from './pages/ReassignmentPage';
import GrantorIntakePage from './pages/GrantorIntakePage';
import GrantorLanding from './pages/GrantorLanding';
import BuiltPage from './pages/BuiltPage';
import AsBuiltPage from './pages/AsBuiltPage';
import PermitsPage from './pages/PermitsPage';
import WorkOrdersPage from './pages/WorkOrdersPage';
import CrewsPage from './pages/CrewsPage';
import ReportsPage from './pages/ReportsPage';
import GeoDataPage from './pages/GeoDataPage';
import SettingsPage from './pages/SettingsPage';
import UsersPage from './pages/UsersPage';
import SystemRecoveryPage from './pages/SystemRecoveryPage';
import BudgetsPage from './pages/BudgetsPage';
import PricingPage from './pages/PricingPage';
import DeploymentConfigPage from './pages/DeploymentConfigPage';
import GettingStartedPage from './pages/GettingStartedPage';
import ObligationCatalogPage from './pages/ObligationCatalogPage';
import GrantAssignmentsPage from './pages/GrantAssignmentsPage';
import GrantAwardsPage from './pages/GrantAwardsPage';
import MakeReadyRiskPage from './pages/MakeReadyRiskPage';
import SampleDataPage from './pages/SampleDataPage';
import VendorsPage from './pages/VendorsPage';
import BusinessCasePage from './pages/BusinessCasePage';
import BusinessCaseReportPage from './pages/BusinessCaseReportPage';
import IntegrationsPage from './pages/IntegrationsPage';
import ReimbursementPage from './pages/ReimbursementPage';
import ReimbursementPacketPage from './pages/ReimbursementPacketPage';
import BeadReportPage from './pages/BeadReportPage';
import CommittedPlansPage from './pages/CommittedPlansPage';
import TerritoryPlanPage from './pages/TerritoryPlanPage';
import LoginPage from './pages/LoginPage';
import PricingModelPage from './pages/PricingModelPage';
import PerformanceMeasuresPage from './pages/PerformanceMeasuresPage';
// New stub pages (Sprint 0 / Sprint 1 — see BEAD_COMPLIANCE_AND_PM_SPEC.md)
import ConstructionPage from './pages/ConstructionPage';
import ProductionPage from './pages/ProductionPage';
import CompliancePage from './pages/CompliancePage';
import ReadyNetIntegrationPage from './pages/ReadyNetIntegrationPage';
import BABALedgerPage from './pages/BABALedgerPage';
import EHPPage from './pages/EHPPage';
import DavisBaconPage from './pages/DavisBaconPage';
import WH347Page from './pages/WH347Page';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';
import InvoicesPage from './pages/InvoicesPage';
import ReportGetPaidPage from './pages/ReportGetPaidPage';
import QBOMappingPage from './pages/QBOMappingPage';
import AccountingMappingPage from './pages/AccountingMappingPage';
import ProcurementPage from './pages/ProcurementPage';
import ComplianceRulesPage from './pages/ComplianceRulesPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/ready/oauth/callback" element={<ReadyOAuthCallback />} />
      <Route element={<AppLayout />}>
        {/* The front door depends on what kind of box this is: a state broadband
            office lands on its oversight queue, an ISP on the project dashboard. */}
        <Route path="/" element={<GrantorLanding />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        {/* Builder = the fiber design sketchbook (was /map). */}
        <Route path="/builder" element={<MapPage />} />
        {/* Grantor-only. The API 404s on an ISP box and the nav entry is hidden. */}
        <Route path="/descope" element={<DeScopePage />} />
        {/* The state's builder: selection and pricing, no design tools. Separate from
            /builder so the operator's design surface is untouched. */}
        <Route path="/grantor/builder" element={<GrantorBuilderPage />} />
        {/* Grantor oversight desk. Inert on an ISP box - the backing API 404s and the
            nav entries are grantorOnly, so neither route is ever reachable there. */}
        <Route path="/grantor" element={<GrantorQueuePage />} />
        <Route path="/grantor/ledger" element={<GrantorLedgerPage />} />
        <Route path="/grantor/reassignment" element={<ReassignmentPage />} />
        {/* Intake desk: a request becomes a record here before it becomes an engine run. */}
        <Route path="/grantor/intake" element={<GrantorIntakePage />} />
        <Route path="/map" element={<Navigate to="/builder" replace />} />
        {/* Built = promoted + lit network. Read-mostly. */}
        <Route path="/built" element={<BuiltPage />} />
        <Route path="/as-built" element={<AsBuiltPage />} />
        <Route path="/permits" element={<PermitsPage />} />
        <Route path="/work-orders" element={<WorkOrdersPage />} />
        <Route path="/crews" element={<CrewsPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/bead-report" element={<BeadReportPage />} />
        <Route path="/plans-of-record" element={<CommittedPlansPage />} />
        <Route path="/territory" element={<Navigate to="/builder" replace />} />
        {/* Settings is no longer top-level — reached via gear button inside Builder. */}
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/users" element={<UsersPage />} />
        <Route path="/settings/system" element={<SystemRecoveryPage />} />
        <Route path="/budgets" element={<BudgetsPage />} />
        <Route path="/schedule" element={<Navigate to="/construction" replace />} />
        <Route path="/costs" element={<Navigate to="/settings/pricing?tab=overrides" replace />} />
        <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
        <Route path="/settings/catalog" element={<Navigate to="/settings/pricing?tab=catalog" replace />} />
        <Route path="/settings/pricing" element={<PricingPage />} />
        <Route path="/settings/deployment" element={<DeploymentConfigPage />} />
        <Route path="/settings/getting-started" element={<GettingStartedPage />} />
        <Route path="/compliance/obligations" element={<ObligationCatalogPage />} />
        <Route path="/compliance/grants" element={<GrantAssignmentsPage />} />
        <Route path="/compliance/awards" element={<GrantAwardsPage />} />
        <Route path="/compliance/makeready" element={<MakeReadyRiskPage />} />
        <Route path="/settings/sample-data" element={<SampleDataPage />} />
        <Route path="/vendors" element={<VendorsPage />} />
        <Route path="/business-case" element={<BusinessCasePage />} />
        <Route path="/geo-data" element={<GeoDataPage />} />
        <Route path="/project-economics" element={<BusinessCasePage />} />
        <Route path="/business-case-report" element={<BusinessCaseReportPage />} />
        <Route path="/project-economics-report" element={<BusinessCaseReportPage />} />
        <Route path="/settings/integrations" element={<IntegrationsPage />} />
        <Route path="/settings/qbo-mapping" element={<AccountingMappingPage />} />
        <Route path="/settings/accounting-mapping" element={<AccountingMappingPage />} />
        <Route path="/bead-compliance/reimbursement" element={<Navigate to="/draws" replace />} />
        <Route path="/bead-compliance/reimbursement/:projectId" element={<Navigate to="/draws" replace />} />
        <Route path="/bead-compliance/reimbursement-packet/:projectId" element={<Navigate to="/draws" replace />} />
        <Route path="/draws/:drawId/packet" element={<ReimbursementPacketPage />} />
        <Route path="/pricing-model" element={<PricingModelPage />} />
        {/* New stub routes (Sprint 0 / Sprint 1) */}
        <Route path="/construction" element={<ConstructionPage />} />
        <Route path="/production" element={<ProductionPage />} />
        <Route path="/compliance" element={<CompliancePage />} />
        <Route path="/state-reporting" element={<Navigate to="/report?tab=state" replace />} />
        <Route path="/report" element={<ReportGetPaidPage />} />
        <Route path="/compliance/rules" element={<ComplianceRulesPage />} />
        <Route path="/compliance/performance-measures" element={<PerformanceMeasuresPage />} />
        <Route path="/integrations/ready-net" element={<ReadyNetIntegrationPage />} />
        <Route path="/bead-compliance/calendar" element={<Navigate to="/compliance" replace />} />
        <Route path="/bead-compliance/baba" element={<BABALedgerPage />} />
        <Route path="/bead-compliance/ehp" element={<EHPPage />} />
        <Route path="/bead-compliance/davis-bacon" element={<DavisBaconPage />} />
        <Route path="/bead-compliance/davis-bacon/wh347/:obligationId" element={<WH347Page />} />
        <Route path="/procurement" element={<ProcurementPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/vendor-pricing" element={<Navigate to="/settings/pricing?tab=vendors" replace />} />
        <Route path="/draws" element={<Navigate to="/report?tab=draws" replace />} />
      </Route>
          </Routes>
  );
}

